import appNavItemTypeCheckers from '../../types/appNavItemTypeCheckers';

const getReportIdsInApp = ({ app }: { app: V3.App }) => {
  try {
    return app.navigationSettings.sections.reduce((acc, section) => {
      const sectionIds = section.items.reduce((itemAcc, item) => {
        if (appNavItemTypeCheckers.isReport(item)) {
          return [...itemAcc, item.reportId];
        }
        if (appNavItemTypeCheckers.isReportsIndex(item)) {
          return [...itemAcc, ...item.reportIds];
        }
        if (appNavItemTypeCheckers.isAllAssets(item)) {
          return [...itemAcc, ...item.reports.map((r) => r.id)];
        }
        return itemAcc;
      }, [] as string[]);

      return [...acc, ...sectionIds];
    }, [] as string[]);
  } catch (e) {
    return [];
  }
};

export default getReportIdsInApp;
